<ion-card class="ion-no-margin" *ngIf="user.profile">
  <ion-card-header class="ion-text-center">
    <ng-container *ngIf="user.profile.profile_picture; else defaultIcon">
      <img [src]="user.profile.profile_picture" alt="">
    </ng-container>
    <ng-template #defaultIcon>
      <ion-icon class="cus-large" name="person-circle-outline"></ion-icon>
    </ng-template>
  </ion-card-header>
  <ion-card-content class="ion-text-center">
    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>First Name</p>
          <h2>{{ user.profile.name }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Last Name</p>
          <h2>{{ user.profile.surname }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Position</p>
          <h2>{{ user.profile.position }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>Business Email</p>
          <h2>{{ user.email }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none" *ngIf="$edit | async">
        <ion-label>
          <p>Business Phone</p>
          <h2>{{ user.profile.phone }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <div class="group-container">
      <ion-item lines="none">
        <ion-label><p>LinkedIn</p></ion-label>
        <a target="_blank" href="{{user.profile.linkedIn}}"> <ion-icon color="primary" name="open-outline"></ion-icon></a>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Office</p>
          <h2>{{ user.profile.business_unit }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Employment Country</p>
          <h2>{{ user.profile.employment_country }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>Manager</p>
          <h2>{{ user.profile.manager?.email }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Managees</p>
          <h2>{{ getManagees() }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <ion-button *ngIf="$edit | async" expand="block" (click)="edit()">Edit</ion-button>
  </ion-card-content>
</ion-card>
